(()=>{
  const flow=document.getElementById('cfh-flow');
  if(!flow)return;
  /* Single-option page: no offer switching. Bounded starter-photo carousel.
     Kept: choose-link scroll, sticky add-to-cart proxy, original trust badge. */

  function initGallery(){
    const gallery=flow.querySelector('[data-flow-gallery]');
    if(!gallery||gallery.dataset.ready==='true')return;
    const hero=gallery.querySelector('#flow-hero-image');
    const thumbs=[...gallery.querySelectorAll('button[data-flow-image]')];
    if(!hero||!thumbs.length)return;
    gallery.dataset.ready='true';
    const rail=gallery.querySelector('.flow-gallery__thumbs');
    const stage=gallery.querySelector('[data-flow-stage]');
        const dialog=gallery.querySelector('dialog');
    let index=Math.max(0,thumbs.findIndex(b=>b.getAttribute('aria-pressed')==='true'));
    const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
    const show=n=>{
      index=(n+thumbs.length)%thumbs.length;
      const button=thumbs[index];
      hero.src=button.dataset.flowImage;
      hero.alt=button.dataset.flowAlt||button.querySelector('img')?.alt||'';
      thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));
            const r=rail.getBoundingClientRect(),t=button.getBoundingClientRect();
      if(t.left<r.left||t.right>r.right)rail.scrollTo({left:rail.scrollLeft+t.left-r.left-(r.width-t.width)/2,behavior:reduced()?'auto':'smooth'});
    };
    thumbs.forEach((button,i)=>button.addEventListener('click',()=>show(i)));
    gallery.querySelector('[data-flow-prev]')?.addEventListener('click',()=>show(index-1));
    gallery.querySelector('[data-flow-next]')?.addEventListener('click',()=>show(index+1));
    gallery.addEventListener('keydown',event=>{
      if(dialog?.open)return;
      if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}
      if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}
    });
    let start=null;
    stage.addEventListener('touchstart',event=>{const t=event.touches[0];start=event.touches.length===1?{x:t.clientX,y:t.clientY}:null;},{passive:true});
    stage.addEventListener('touchend',event=>{if(!start)return;const t=event.changedTouches[0],dx=t.clientX-start.x,dy=t.clientY-start.y;start=null;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.3)show(index+(dx<0?1:-1));},{passive:true});
    stage.addEventListener('touchcancel',()=>{start=null;},{passive:true});
    gallery.querySelector('[data-flow-zoom]')?.addEventListener('click',()=>{
      if(!dialog)return;
      const enlarged=dialog.querySelector('img');enlarged.src=hero.src;enlarged.alt=hero.alt;dialog.showModal();
    });
    gallery.querySelector('[data-flow-close]')?.addEventListener('click',()=>dialog?.close());
    dialog?.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  }
  initGallery();

  /* Choose links scroll to the buy box. */
  flow.querySelectorAll('a[href="#cfh-sd-pdp-selector-v2"],a[href="#cfh-sd-pdp-selector-v3"],a[href="#flow-buy"]').forEach(link=>link.addEventListener('click',e=>{
    e.preventDefault();
    const target=flow.querySelector('[data-add-to-cart-trigger]');
    if(target)target.scrollIntoView({behavior:'smooth',block:'start'});
  }));

  /* Rating link smooth-scrolls to the Stamped reviews widget. */
  flow.querySelector('a[href="#stamped-main-widget"]')?.addEventListener('click',e=>{
    e.preventDefault();
    const target=flow.querySelector('#stamped-main-widget')||document.getElementById('stamped-main-widget');
    if(target)target.scrollIntoView({behavior:'smooth',block:'start'});
  });

  flow.querySelectorAll('[data-flow-choose="starter"]').forEach(b=>b.addEventListener('click',()=>{const main=flow.querySelector('[data-add-to-cart-trigger]');if(main&&!main.disabled)main.click();}));
  // Only tuck away the closed chat launcher while the main purchase button is onscreen.
  const primaryCart=flow.querySelector('[data-add-to-cart-trigger]');
  if(primaryCart&&'IntersectionObserver' in window){
    const visibility=new IntersectionObserver(entries=>{document.body.classList.toggle('flow-primary-cart-visible',entries[0].isIntersecting);},{threshold:0.05});
    visibility.observe(primaryCart);
  }
  /* Sticky add-to-cart proxy clicks the main button.
     Hidden until the visitor scrolls down to the "Millions of First Loaves" section (#flow-reviews),
     then slides up from the bottom. Also hides when the main ATC button is back in view. */
  const stickyWrap=flow.querySelector('.flow-sticky');
  const sticky=flow.querySelector('[data-flow-sticky-add]');
  const main=()=>flow.querySelector('[data-add-to-cart-trigger]');
  if(sticky){
    const sync=()=>{
      const button=main();const busy=!!button?.disabled;
      sticky.disabled=!button||busy;
      sticky.setAttribute('aria-busy',String(busy));
      const text=busy&&/Adding/i.test(button?.textContent||'')?'Adding…':(sticky.dataset.cfhCartLabel||'Add to Cart');
      if(sticky.textContent!==text)sticky.textContent=text;
    };
    sticky.addEventListener('click',()=>{const button=main();if(!button||button.disabled)return;button.click();sync();});
    if(main())new MutationObserver(sync).observe(main(),{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    sync();setTimeout(sync,600);

    /* Sticky bar shows only once the "Millions of First Loaves" section (#flow-reviews)
       reaches the viewport, and hides again when the user scrolls back above it.
     Position gate: visible whenever the section top is at/above the lower part of the
     viewport (covers the buy box above it and everything below the section). */
    if(stickyWrap){
      stickyWrap.classList.add('flow-sticky-hidden');
      const reviews=flow.querySelector('#flow-reviews');
      if(reviews){
        const LINE=0.95; /* reveal when the section top crosses the bottom 5% of the viewport */
        const update=()=>{
          const top=reviews.getBoundingClientRect().top;
          stickyWrap.classList.toggle('flow-sticky-hidden',top>window.innerHeight*LINE);
        };
        update();
        let ticking=false;
        const onScroll=()=>{
          if(ticking)return;ticking=true;
          requestAnimationFrame(()=>{ticking=false;update();});
        };
        window.addEventListener('scroll',onScroll,{passive:true});
        window.addEventListener('resize',onScroll,{passive:true});
        setTimeout(update,600);
      } else {
        stickyWrap.classList.remove('flow-sticky-hidden'); /* fallback: no section found */
      }
    }
  }

  /* Open native Shop Pay Installments modal from custom link */
  flow.querySelector('[data-flow-open-shop-pay]')?.addEventListener('click', () => {
    const spt = document.querySelector('shopify-payment-terms');
    if (spt && spt.shadowRoot) {
      const btn = spt.shadowRoot.querySelector('#shopify-installments-cta') || spt.shadowRoot.querySelector('button');
      if (btn) btn.click();
    }
  });

  const flowQuality = document.getElementById('flow-quality'); if (flowQuality) { flowQuality.style.setProperty('background', '#ffffff', 'important'); flowQuality.style.setProperty('border-block', 'none', 'important'); }

})();
